import Seo from "@/components/Seo";
import { business, telHref } from "@/business-config";
export default function Privacy() {
  return (
    <>
      <Seo title="Confidențialitate" path="/politica-de-confidentialitate" />
      <article className="wrap legal-page">
        <h1>Confidențialitate</h1>
        <p className="legal-lead">
          Utilizarea datelor introduse în formularul de contact.
        </p>
        <h2>Formularul de contact</h2>
        <p>
          Formularul pregătește un mesaj pentru WhatsApp. Datele introduse nu
          sunt trimise către serverul site-ului și nu sunt salvate în browser.
          Câmpurile se golesc la reîncărcarea paginii.
        </p>
        <h2>WhatsApp și Google Maps</h2>
        <p>
          Când alegi „Deschide în WhatsApp”, informațiile introduse sunt incluse
          în linkul către WhatsApp. Trimiterea mesajului se face din aplicația
          respectivă. Linkurile de traseu deschid Google Maps. Aceste servicii
          funcționează conform propriilor politici de confidențialitate.
        </p>
        <h2>Contact</h2>
        <p>
          Pentru întrebări despre datele transmise service-ului, contactează{" "}
          {business.legalName}, {business.address.full}, la{" "}
          <a href={telHref()}>{business.phone.display}</a>.
        </p>
        <h2>Analiză și stocare</h2>
        <p>
          Site-ul nu include instrumente de analiză a vizitelor, publicitate sau
          profilare. Furnizorul de găzduire poate înregistra informații tehnice
          despre acces, în funcție de configurația serviciului.
        </p>
      </article>
    </>
  );
}
